"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = void 0;

var _util = require("../../../util");

const wrapper = ({
  theme,
  cssProps
}) => {
  const {
    card
  } = theme;
  const {
    variant = 'primary',
    color: bgColor = 'tan',
    rounded = true,
    width = 'inline',
    interactive = false
  } = cssProps;
  const cardTheme = card[variant];
  const isSecondary = variant === 'secondary';
  const isInteractive = variant.includes('interactive');
  const isFullWidth = width === 'full';
  return {
    display: 'flex',
    width: isFullWidth ? '100%' : undefined,
    background: isSecondary ? (0, _util.color)(theme, "background.".concat(bgColor)) : (0, _util.color)(theme, cardTheme.bg),
    boxShadow: (0, _util.boxShadow)(theme, cardTheme.boxShadow),
    borderRadius: isSecondary && !rounded ? 'none' : cardTheme.borderRadius,
    cursor: interactive ? 'pointer' : cardTheme.cursor,
    transition: 'background 0.2s ease',
    '&:hover': isInteractive ? {
      background: (0, _util.color)(theme, cardTheme.bgHover)
    } : undefined,
    '&:active': isInteractive ? {
      background: (0, _util.color)(theme, cardTheme.bgActive)
    } : undefined
  };
};

exports.wrapper = wrapper;
//# sourceMappingURL=Card.style.js.map